import React from "react";
import { Button, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

export default function SkeyecubeProjectsTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
  onDeleteProject,
  isRoleUser,
}) {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "25%",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      width: "25%",
      sorter: (a, b) => (a.owner || "").localeCompare(b.owner || ""),
    },
    {
      title: "Num Cubes",
      dataIndex: "num_cubes",
      key: "num_cubes",
      width: "15%",
      sorter: (a, b) => (a.num_cubes || 0) - (b.num_cubes || 0),
    },
    {
      title: "Created",
      dataIndex: "created",
      key: "created",
      width: "25%",
      sorter: (a, b) => (a.created || "").localeCompare(b.created || ""),
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) =>
        !isRoleUser && (
          <Popconfirm
            title="Delete Project"
            description={`Are you sure you want to delete project "${record.name}"?`}
            onConfirm={() => onDeleteProject(record.name)}
            okText="Yes"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Button
              type="text"
              danger
              icon={<DeleteOutlined />}
              title="Delete Project"
            />
          </Popconfirm>
        ),
    },
  ];

  return (
    <DataTable
      rowKey="name"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
